import React from 'react';
import { X, MessageSquare } from 'lucide-react';
import type { Post } from '../types';
import { LiveChat } from './LiveChat';
import { AudioChat } from './AudioChat';

interface LiveChatViewProps {
  post: Post;
  onClose: () => void;
}

export function LiveChatView({ post, onClose }: LiveChatViewProps) {
  return (
    <div className="fixed inset-0 bg-black z-[70] flex flex-col overflow-hidden safe-area-top">
      <div className="absolute top-4 right-4 z-10 safe-area-top">
        <button
          onClick={onClose}
          className="bg-black/50 p-2 rounded-full hover:bg-black/70 transition-colors"
        >
          <X className="w-6 h-6 text-white" />
        </button>
      </div>

      <div className="flex-1 flex flex-col overflow-hidden mt-0">
        <div className="flex-1 bg-black flex flex-col overflow-hidden">
          <div className="p-3 sm:p-4 border-b border-gray-800">
            <div className="flex items-center gap-3 mb-4">
              <img
                src={post.userAvatar}
                alt={post.username}
                className="w-10 h-10 sm:w-12 sm:h-12 rounded-full"
              />
              <div>
                <p className="font-semibold text-white">@{post.username}</p>
                <p className="text-white text-xs sm:text-sm mt-1 line-clamp-2">{post.caption}</p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <MessageSquare className="w-5 h-5 text-white" />
              <h2 className="text-lg sm:text-xl font-bold text-white">Live Chat</h2>
            </div>
            <p className="text-gray-400 text-sm">Chat with other viewers in real-time</p>
          </div>
          <AudioChat postId={post.id} />
          <LiveChat postId={post.id} />
        </div>
      </div>
    </div>
  );
}